import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const requestContextInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiNexus) || req.headers.has('X-Request-ID')) {
    return next(req);
  }

  return next(req.clone({
    setHeaders: { 'X-Request-ID': createRequestId() },
  }));
};

function createRequestId(): string {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, character => {
    const random = Math.floor(Math.random() * 16);
    const value = character === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
}
